import { Div } from "@tblabs/truffle";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";


export class PageFooter extends Div
{
    constructor(private _shop: ShopContentProvider)
    {
        super("footer");

        this.Html(`<footer>
        <div class="footer-container">
            <div class="footer-content">
                <img src="${this._shop.Shop.Logo.value}" alt="Logo" class="footer-logo">
                <nav class="footer-nav">
                    <a href="https://facebook.com/specteamwypozyczalnia#" class="footer-link facebook-link" target="_blank" rel="noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-facebook-icon lucide-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                        </svg>
                        Facebook
                    </a>
                    <a href="https://www.instagram.com/specteam.pl/" class="footer-link facebook-link" target="_blank" rel="noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-instagram-icon lucide-instagram"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                        </svg>
                        Instagram
                    </a>
                    <a href="https://www.youtube.com/@specteam-pl" class="footer-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-youtube-icon lucide-youtube"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/><path d="m10 15 5-3-5-3z"/>
                        </svg>
                        Youtube
                    </a>
                </nav>
            </div>
        </div>
    </footer>`);
    }
}
